"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("@mui/material/Link"));
var _propTypes = _interopRequireDefault(require("prop-types"));
const _excluded = ["label", "href", "newTab"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const AnchorLink = _ref => {
  let {
      label,
      href,
      newTab
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (newTab) {
    return /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
      href: href,
      title: label,
      target: "_blank",
      rel: "noopener"
    }, rest), label);
  }
  return /*#__PURE__*/_react.default.createElement(_Link.default, _extends({
    href: href,
    title: label
  }, rest), label);
};
AnchorLink.propTypes = {
  label: _propTypes.default.string,
  href: _propTypes.default.string,
  newTab: _propTypes.default.bool
};
var _default = exports.default = AnchorLink;